import { pPartFromFirestore } from '@parallel-fluidics/shared/models/projects/parts';
import { doc, getDoc, getFirestore } from 'firebase/firestore';

export default function fetchProjectPart({ projectDocId, pPartDocId }) {
  const pPartDocRef = doc(getFirestore(), 'projects', projectDocId, 'parts', pPartDocId);
  return getDoc(pPartDocRef).then((pPartDoc) => {
    if (pPartDoc.exists()) {
      return pPartFromFirestore(pPartDoc);
    }
    throw new Error('Project Part not found');
  });
}
